export default __webpack_public_path__ + "static/media/numen-partner.ce24f1ae.svg";